import { gql, useQuery } from '@apollo/client'

import {
  ItemDetailBoxFragmentDoc,
  ResaleCreateQuery,
  ResaleCreateQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { decodeSkuId, setItemSku } from '@/core/sku'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ itemId: string; skuId?: string }>()
  const { data, loading } = useQuery<
    ResaleCreateQuery,
    ResaleCreateQueryVariables
  >(QUERY, {
    variables: {
      id: router.query.itemId,
      skuId: decodeSkuId(router.query.skuId ?? '') || undefined,
    },
  })

  return {
    state: {
      item: setItemSku(data?.item ?? null, router.query.skuId),
      loading,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ResaleCreatePrecaution($id: ID!, $skuId: String) {
    item(id: $id) {
      ...ItemDetailBox
    }
  }
  ${ItemDetailBoxFragmentDoc}
`
